"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var index_exports = {};
__export(index_exports, {
  default: () => index_default,
  initPtBrTranslations: () => initPtBrTranslations
});
module.exports = __toCommonJS(index_exports);
var import_platform = require("@hcengineering/platform");
var import_tracker = require("@hcengineering/tracker");
var import_task = require("@hcengineering/task");
async function initPtBrTranslations() {
  (0, import_platform.addStringsLoader)(import_tracker.trackerId, async (lang) => {
    const original = await import(`@hcengineering/tracker-assets/lang/${lang}.json`);
    if (lang === "pt-br") {
      const overrides = await import("../lang/pt-br-tracker.json");
      return {
        ...original,
        string: { ...original.string, ...overrides.string }
      };
    }
    return original;
  });
  (0, import_platform.addStringsLoader)(import_task.taskId, async (lang) => {
    const original = await import(`@hcengineering/task-assets/lang/${lang}.json`);
    if (lang === "pt-br") {
      const overrides = await import("../lang/pt-br-task.json");
      return {
        ...original,
        string: { ...original.string, ...overrides.string }
      };
    }
    return original;
  });
}
__name(initPtBrTranslations, "initPtBrTranslations");
var index_default = initPtBrTranslations;
//# sourceMappingURL=index.js.map
